import { UsersRequestParams } from './types';

export const defaultUsersParams: UsersRequestParams = {
  limit: 10,
  order_dir: 'desc'
};
